
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Dies wird durch das
                    <a href="${0}">Folksonomy Engine Projekt</a>ermöglicht. Zögern Sie nicht,
                    teilzunehmen oder Feedback zu geben`,
'h5d824b4954e56ea5': html`Scannen Sie <span class="everyday">täglich Ihre</span> <span class="foods">Lebensmittel</span>`,
'h6bdd1b427aa985a4': html`Mit diesem Tool können Sie die Zutatenliste korrigieren. Sie können
                Zutaten hinzufügen, entfernen oder bearbeiten.
                <br>
                Dieses Zeichen <span class="highlight">␣</span> steht für ein Leerzeichen.
                <br>
                Dieses Zeichen <span class="highlight">↩︎</span> steht für einen Zeilenumbruch. `,
'hb28f1f2ec1744ee9': html`Diese Eigenschaften werden von Benutzern für jede Art von Nutzung erstellt und abgelegt. Fühlen Sie sich
                    frei, um Ihre eigenen hinzuzufügen. Die Eigenschaften und Werte, die Sie
                    <strong>erstellen, müssen faktisch</strong>sein. Sie können eintauchen in
                    <a href="${0}">die Liste der bereits von der Gemeinschaft</a>
                    verwendeten Objekte oder die Dokumentation der
                   <a href="${1}">Immobilien und deren Suchmaschine</a>.`,
's000a5b76bd3a01c2': `Eigenschaften werden geladen ...`,
's000d98595e959c1e': `Erhältlich bei Google Play`,
's013bdc8cf0d3583d': `Helfen Sie uns bei der Suche nach Zutaten`,
's01d2865e3e1d5501': `Vielen Dank für Ihre Mithilfe!`,
's02ce7a2e7c1b020b': `Zuschnitt bestätigen`,
's03e9c8114521b998': `Ich werde die Zutaten bearbeiten`,
's05ec315d9308091a': `Barcode-Ecken-Symbol`,
's061eb5af92512c85': `Gespeichert! Können Sie mit einem anderen helfen?`,
's06847c221c4c0bc1': `Ich möchte eine Eigenschaft erstellen, um [hier Beschreibung hinzufügen] ...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Gruppierte Werte`,
's09205907b5b56cda': `Nein`,
's0b4235aae602a950': `spezielle Dokumentation`,
's0bb2d48532acc455': `CSV herunterladen`,
's0d5b7fee0311db68': `Eigenschaft`,
's0fb218abc2e157ed': `Ungültiges Bild`,
's100c4928cc74642a': `die Förderung der Forschung im Bereich der öffentlichen Gesundheit zu unterstützen.`,
's10db5498186c083b': `Zuschneiden abbrechen`,
's11a18a69b30b65ed': `Helfen Sie uns, Fehler in der Zutatenliste zu beheben`,
's1205d5f6fccf8e69': `Eigenschaftswert`,
's15d64a0a6715285a': `Neuer Schlüssel`,
's166bd56d19670a72': `Vergrößern`,
's19059bf0c4f7c162': `Auswahlbereich`,
's1a52515ec8ddade8': `Produkt-Strichcode`,
's1c5031113de500ce': `unsere Datenbank offen und für alle zugänglich zu halten,`,
's1dc4daf989c71284': `Helfen Sie uns, die Nährwertangaben zu korrigieren`,
's1e00019dc454872d': `Bitte geben Sie mithilfe des Attributs „property-name“ einen Eigenschaftsnamen an.`,
's1e49126af0935a5b': `Liste der Produkte, die diese Eigenschaft verwenden`,
's21e73088de6f26f3': `Erhältlich im App Store`,
's255857544a9d5ec0': `Zurücksetzten`,
's25e94495991e95ba': `Vielen Dank für Ihre Hilfe! Könnten Sie auch bei einer anderen Frage helfen?`,
's2ceb11be2290bb1b': `Abbrechen`,
's2db7b654c0a9bde0': `Dokumentieren Sie die Eigenschaft`,
's300b3a6ee4e1252d': str`Schlechte Übereinstimmung ${0}%`,
's33f786bb6b4f0cf4': `Ergebnis des Zuschnitts`,
's33f85f24c0f5f008': `Speichern`,
's34be4af4e8fec4ae': `Fragen Sie zuerst die Community`,
's36d86adc823cbfa6': `Bevor Sie eine neue Eigenschaft erstellen, besprechen Sie diese bitte zuerst mit der Gemeinschaft:`,
's3781d25aa51a736c': `Folksonomy Engine-Dokumentation`,
's383ae4449428b61e': `Zuschnitt zurücksetzen`,
's39bcf88721a1e8ee': `Auswahl zurücksetzen`,
's39e14e14300694c7': `Dokumentation und Richtlinien`,
's3b430cfa5c1fe7f4': str`Dokumentation für ${0}`,
's3f4e4b52f230a892': `Bildleinwand`,
's417b90913e05bc17': `Vorschau`,
's41f7dca46d3f1b4a': `Wert`,
's422bba9636ce2489': `Bild zentrieren`,
's42dd66b2441566fd': `Symbol zentrieren`,
's43df2e8395f6834e': str`Bitte unterstützen Sie unsere Spendenaktion ${0}`,
's453188ea728f64da': `Nährstoff hinzufügen`,
's453ab0dbb9b5c777': `Größe rechts ändern`,
's475b08749d0706ed': `Helfen Sie uns, Millionen von Verbrauchern auf der ganzen Welt darüber zu informieren, was sie essen`,
's49730f3d5751a433': `Wird geladen …`,
's4bbc7472834a9686': `Ihr Browser unterstützt kein Einlesen von Strichcodes.`,
's4d42cc7e00076a3b': `Produktanzahl`,
's4df2f533c0c1e7d0': `Bild-Bedienelemente`,
's4e94adf723979402': `Open Food Facts benötigt Ihre Unterstützung bei diesem Produkt.`,
's4f4886341969d552': `Auswahl verschieben`,
's4f751fb9b3ed766c': `Neue Eigenschaft wird erstellt`,
's547c12ae169d00bc': `Verfügbar auf F-Droid`,
's5560fb119e40923d': `Namen der Eigenschaft eingeben ...`,
's55d7249883a98ca1': `über diese Eigenschaft auf Open Food Facts Wiki`,
's565867d84c04aea2': `Filtereigenschaften ...`,
's5666afe5cd0166de': `Bevor Sie bestätigen, beheben Sie bitte die Fehler oder ändern Sie den Text`,
's57472465a23b41db': `Werte`,
's58e1eeea7a60ae51': `Produkte werden geladen ...`,
's59df20feee978e5b': `Fehler: Ungültiger Wert.`,
's5c92c0051d44b6de': `Helfen Sie uns, die Nährwertangaben zu korrigieren.`,
's5dd6f12783fca34f': `Zutatenliste bearbeiten`,
's5e8250fb85d64c23': `Schließen`,
's5ed03bb1f3a15949': `Bild`,
's6306a31415aea913': `ICH UNTERSTÜTZE`,
's6498dfe4855bb3a7': `Einheit`,
's64ef2a6c2dd1d3d1': `Bearbeiten`,
's66413c24dcf680e2': `Überspringen`,
's67ae6594857a4d57': `Danke für Ihren Beitrag!`,
's6cee7cad81dfedd1': `Zugeschnittenes Bild`,
's6d7b6cdedaadfb6e': `Jede Spende zählt! Wir freuen uns über Ihre Unterstützung bei der Schaffung von mehr Lebensmitteltransparenz in der Welt.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Gute Übereinstimmung ${0}%`,
's71a5c9f4b68ef4d4': `Anzahl`,
's74cb3d66f6a668e1': `Dokumentation`,
's787dd11bed0dc88a': `Größe links ändern`,
's7ce4fd9430e80cea': `Werte`,
's801a05fa8e881f37': `Erfahren Sie mehr über die Erstellung von Eigenschaften und Richtlinien:`,
's8038273de2cf8b73': `Bitte eine Region zum Zuschneiden auswählen.`,
's839cc2908a5387f2': `Strichcodes filtern ...`,
's86197dcf3e96af64': `Vorhandene Eigenschaften durchsuchen und nach ihnen suchen`,
's8a63be30a129a59c': `Größe unten ändern`,
's8a8bfd67f2dd2810': `Laden Sie die OFF-App mit diesem QR-Code herunter`,
's8af61807443f32a4': `Aktionen`,
's8b33c244759d7bd4': `Größe oben rechts ändern`,
's8db84aa4bc949af2': `Neue Eigenschaft dokumentieren`,
's8f839a03997a16d7': `Produkt anzeigen`,
's901ae1e236ac45d3': `Löschen abbrechen`,
's907f7a97c6b29425': `Beachten Sie, dass das Datenmodell möglicherweise geändert wird. Die Verwendung erfolgt auf eigene Gefahr.`,
's95d23d03f9147581': `Vergrößern beenden`,
's976dfd19ef58a1e1': `Klicken Sie hier, um einen Strichcode einzulesen und Details zu erfahren (Gesundheit, Vorlieben usw.)`,
's98ff35f2a00dc60d': `Zutaten:`,
's9a7f60fce090ecaf': `Eigenschaften konnten nicht geladen werden. Bitte versuchen Sie es später noch einmal.`,
's9b87abd68fb9df45': `Nicht gefunden? Neuen Schlüssel erstellen {value}`,
's9c0f52425fd2f07e': `Kann nicht übereinstimmen`,
's9fc41f789c63b40d': `Produkte`,
'sa1fa766e0d5634d7': `Keine Partitur verfügbar`,
'sa548778b24054030': `Entdecken Sie alle bereitgestellten Eigenschaften aus dem Folksonomy Engine-Projekt. Diese Eigenschaften bieten zusätzliche Metadaten und Einblicke zu Produkten in der Open Food Facts-Datenbank.`,
'sa63907958bd0ec4b': `Größe oben links ändern`,
'sa95b4224f685a36a': `Modal schließen`,
'sab56a1d439576fd6': `Vorschlagssymbol`,
'sac47ea2901d04c15': `Größe unten links ändern`,
'sb125227d436c2925': `Suchen Sie Ihr Eigenschaftenkonzept in der bestehenden Eigenschaftendatenbank:`,
'sb125568d43642e6f': `Beantworten Sie Fragen zum Produkt.`,
'sb1c538e038f9b214': str`Sehr gute Übereinstimmung ${0}%`,
'sb28639570ff3b852': `Liste aller Eigenschaften`,
'sb3bdd638a58d30f4': `eine Gemeinschaft engagierter Bürger einbinden,`,
'sb3cbcc1bd0fff140': `Sobald Sie überprüft haben, dass Ihre Eigenschaft noch nicht vorhanden ist und die Gemeinschaft zustimmt, dass sie nützlich ist, müssen Sie sie zunächst im Wiki dokumentieren.`,
'sb3d4f79d9d8b71e5': `Senden`,
'sb560fa37a7bfb6c2': `Mit dieser Eigenschaft wurden keine Produkte gefunden.`,
'sb7f72e4c8a2d3357': `Filterwerte ...`,
'sb8178320160f84ea': `Zuschnitt anzeigen`,
'sbad7d2734149470b': `Bestätigen`,
'sbb623d6b18d966a0': `Die Nährwertangaben sind auf der Verpackung angegeben:`,
'sbd6be5cde472f37c': `Alle Fragen wurden beantwortet! Vielen Dank für Ihre Hilfe!`,
'sbd9a0b2293b3cd3c': `Portionsgröße`,
'sbe472dc3c2685985': `Entsprechender Wert`,
'sc0520e1732a5c568': `Bild vergrößern`,
'sc0cc559e7ede852a': `Größe oben ändern`,
'sc1c08d0cbcc3bd24': `Stimmt nicht überein`,
'sc52696641af72b53': `Installieren Sie die App!`,
'sc5575e3107f87874': `Bild nach links drehen`,
'sc57b630a7a70c61f': `Vorgeschlagene Lösung`,
'sc681b137e8f604f7': `Löschung bestätigen`,
'sc6daf8a31883f8b9': `Bild verschieben`,
'sc895972c88d38ca5': `Folksonomy-Eigenschaft`,
'sca0c3305aff570b8': str`pro angegebenen Server "${0}"`,
'scace072bef961918': `Zeilen`,
'scb3b0671d7b7f640': `Neuer Wert`,
'scb489a1a173ac3f0': `Ja`,
'scbab4bd737ba7934': str`Gruppenfoto spende ${0}`,
'scd21019c3cd618f3': `Nehmen Sie an der Slack-Diskussionen teil`,
'scdb6cad0b92721bf': `Keine Eigenschaften gefunden.`,
'scf23a05631f93732': `Löschen bestätigen`,
'scfed2f270ef6a3aa': `Bereich auswählen`,
'sd1022bc1ef9204f7': `Vergrößerbares Bild`,
'sd1077c055cf9ba6b': `Helfen Sie uns, die Liste der Zutaten des Produkts zu überprüfen.`,
'sd698d21ddecba56b': `Hallo! Sie können uns helfen, die Produktinformationen zu verbessern, indem Sie die folgenden Teile beantworten:`,
'sd82bc2decefa621b': `unabhängig von der Lebensmittelindustrie bleiben,`,
'sdb97e5976482606e': `Überprüft, ob eine Eigenschaft bereits vorhanden ist`,
'sdbf806fefc584115': `Sie sollten einen`,
'sdc673e73b5c13aea': `Löschen`,
'sdc792b75f1edcaba': `Helfen Sie uns, die Rechtschreibung der Zutaten zu korrigieren.`,
'sdca5deead576ceee': `Größe ändern unten rechts`,
'sdcc2555c5dde524f': `Möchten Sie diesen Artikel wirklich löschen? Diese Aktion kann nicht widerrufen werden.`,
'se206feec7ec57b28': `pro 100g`,
'se419a9ab36987490': `Für ungültig erklären`,
'se5127cf0f92e7e48': `Tipp: Sie finden auch die`,
'se773f50d2a16d481': `Bild nach rechts drehen`,
'sebb2c6c830a44574': `Technische Infrastruktur (Website/Mobile App) und ein kleines festes Team`,
'sec6377f3c4e9b28c': `Ich werde einen besseren Zuschnitt vorschlagen`,
'seea3800e27baa686': `Einzelne Produkte`,
'sefaba4adc4ec9219': `Folksonomy-Eigenschaften`,
'seffa8ca49175b5f0': `Personalisierte Eigenschaften`,
'sf44a6b3b232c28ea': str`Aktuellen Wert durch ${0} ersetzen`,
'sf4cd86a2f5ef2588': `Strichcode des Produkts`,
'sf57a61152168cc81': `Helfen Sie uns, die Inhaltsstofferkennung zu korrigieren`,
'sf88b90b8ba23871c': `Unbekannte Übereinstimmung`,
'sf9aee319a006c9b4': `Hinzufügen`,
'sfacbbe968fa7d773': `Name der Eigenschaft:`,
'sfc40ea3d5d5aa6f8': `Ihre Spenden finanzieren den laufenden Betrieb unserer gemeinnützigen Vereinigung:`,
'sfe87465d50530725': `Entsprechender Wert`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  